export default  {
    "align": "align",
    "image": "image",
    "list": "list",
    "link": "link",
    "unlink": "unlink",
    "table": "table",
    "font": "font",
    "full screen": "full screen",
    "text": "text",
    "eraser": "remove format",
    "info": "info",
    "color": "color",
    "please enter a url": "please enter a url",
    "create link": "create link",
    "bold": "bold",
    "italic": "italic",
    "underline": "underline",
    "strike through": "strike through",
    "subscript": "subscript",
    "superscript": "superscript",
    "heading": "heading",
    "font name": "font name",
    "font size": "font size",
    "left justify": "left justify",
    "center justify": "center justify",
    "right justify": "right justify",
    "ordered list": "ordered list",
    "unordered list": "unordered list",
    "fore color": "fore color",
    "background color": "background color",
    "row count": "row count",
    "column count": "column count",
    "save": "save",
    "upload": "upload",
    "progress": "progress",
    "unknown": "unknown",
    "please wait": "please wait",
    "error": "error",
    "abort": "abort",
    "reset": "reset",
    "hr": "horizontal rule",
    "undo": "undo",
    "line height": "line height",
    "exceed size limit": "exceed size limit"
}


// WEBPACK FOOTER //
// ./src/components/editor/src/i18n/en-us.js